<template>
  <section id="home-mar">
    <b-container fluid class="set_size">
    <div>
      <b-navbar>
        <b-navbar-brand class="logo-mar">
          <img src="../../assets/mar/img/Mar_Logotipo.png" class="d-inline-block align-top" alt="Mar">
        </b-navbar-brand>
        <b-navbar-nav class="ml-auto sections-name gotham-book-regular">
          <b-nav-item class="mr-5" href="#">
            <router-link :to="{path: '/'}" tag="span">MARABUNTA</router-link>
          </b-nav-item>
          <b-nav-item class="mr-5" href="#about">ACERCA</b-nav-item>
          <b-nav-item href="#contact">CONTACTO</b-nav-item>
        </b-navbar-nav>
      </b-navbar>
      <div class="logoMar-responsive text-center">
        <img src="../../assets/mar/img/Mar_Logotipo.png" class="d-inline-block align-top" alt="Mar">
      </div>
    </div>
    <div class="nav-separation">
      <b-row class="justify-content-center">
        <b-col class="row-home" cols="10" sm="8" md="7" lg="8" xl="7" offset="0" offset-sm="1" offset-md="1" offset-lg="1" offset-xl="1">
          <div class="img-home">
            <div>
              <span class="text-right txt-img">DESIGN
                <br>
                 MADE 
                <br> 
                 SIMPLE
              </span>
              <b-img :src="require('../../assets/mar/img/ainicio.jpg')" fluid alt="Responsive image"></b-img>
              <b-img :src="require('../../assets/mar/img/resource1.png')" fluid alt="Responsive image"></b-img>
              <b-img :src="require('../../assets/mar/img/resource2.png')" fluid alt="Responsive image"></b-img>
            </div>
            <div>
              <b-img :src="require('../../assets/mar/img/mar_created.png')" fluid alt="Responsive image"></b-img>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row id="about" class="justify-content-center about-separation">
        <b-col cols="12" sm="11" md="11" lg="11" xl="10">
          <div class="txt-about">
            <p>
              Mar es una marca que busca facilitar <span>diseños de calidad</span> a negocios locales, pequeños y emprendedores jóvenes; busca ser la rama de una agencia creativa profesional, Marabunta, dedicada a proveer soluciones accesibles en modelos tipo llave en mano para todos nuestros clientes. 
              <br><br>
              Somos un estudio creativo de talentosas especialistas en áreas como diseño, community management, experiencia de usuario y comunicación. Además, <span>¡nos encanta crear conceptos, diseñar soluciones multidisciplinarias y escuchar a nuestros clientes!</span> 
              <br><br>
              En Mar tomamos tus grandes ideas y las convertimos en diseños innovadores, que comuniquen, sean funcionales y sobretodo que tengan <span>un propósito.</span>
            </p>
          </div>
        </b-col>
      </b-row>
      <b-row class="justify-content-center services-separation">
        <b-col cols="12" sm="11" md="10" lg="10" xl="8">
          <div class="text-center txt-services">
            <h2>NUESTROS SERVICIOS</h2>
            <p>Contamos con 8 mares —paquetes de diseño— pensando en las necesidades principales de nuestros clientes y cómo satisfacerlas. ¡Descúbrelas!</p>
          </div>
        </b-col>
      </b-row>
      <b-row class="content-separation">
        <b-col class="sm-r5 order-smr-1" cols="6" sm="5" md="4" lg="4" xl="4" order="1" order-sm="1" order-md="1" order-lg="1" order-xl="1">
          <div class="mar-img1">
            <div class="service-content">
              <b-img :src="require('../../assets/mar/img/beach-ocean-sea-seafoam.jpg')" fluid alt="Responsive image"></b-img>
              <div class="hover-service hover-mar1">
                <p>Mar<br> Caribe</p>
              </div>
            </div>
            <div class="mar-txt">
              <p>
                Mar Caribe 
                <br>
                <span>Creación de contenido</span>
              </p>
              <div class="text-right">
                <a href="https://marabunta.work/docs/Mar-Caribe-CreaciónContenido.pdf" target="_blank">
                  Descarga el catálogo
                  <span><icon-base icon-name="Arrow Down"><icon-arrow-down /></icon-base></span>
                </a>
              </div>
            </div>
          </div>
        </b-col>
        <b-col class="sm-r5 order-smr-2 offset-r0 offset-smr-2" cols="6" sm="5" md="4" lg="4" xl="4" order="2" order-sm="2" order-md="2" order-lg="2" order-xl="2" offset-sm="2" offset-md="0">
          <div class="mar-img2">
            <div class="service-content">
              <b-img :src="require('../../assets/mar/img/aerial-shot-of-blue-water.jpg')" fluid alt="Responsive image"></b-img>
              <div class="hover-service hover-mar2">
                <p>Mar<br> Báltico</p>
              </div>
            </div>
            <div class="mar-txt">
              <p>
                Mar Báltico 
                <br>
                <span>Asesorías</span>
              </p>
              <div class="text-right">
                <a href="https://marabunta.work/docs/Mar-Baltico-Asesorias.pdf" target="_blank">
                  Descarga el catálogo
                  <span><icon-base icon-name="Arrow Down"><icon-arrow-down /></icon-base></span>
                </a>
              </div>
            </div>
          </div>
        </b-col>
        <b-col class="sm-r5 order-smr-3 offset-smr-1" cols="6" sm="5" md="4" lg="4" xl="4" order="3" order-sm="3" order-md="3" order-lg="3" order-xl="3">
          <div class="mar-img3">
            <div class="service-content">
              <b-img :src="require('../../assets/mar/img/aerial-photography-of-rocks-beside-body-of-water.jpg')" fluid alt="Responsive image"></b-img>
              <div class="hover-service hover-mar3">
                <p>Mar<br> Egeo</p>
              </div>
            </div>
            <div class="mar-txt text-right">
              <p>
                Mar Egeo 
                <br>
                <span>Branding</span>
              </p>
              <div class="text-right">
                <a href="https://marabunta.work/docs/Mar-Egeo-Branding.pdf" target="_blank">
                  Descarga el catálogo
                  <span><icon-base icon-name="Arrow Down"><icon-arrow-down /></icon-base></span>
                </a>
              </div>
            </div>
          </div>
        </b-col>
      <!-- </b-row>
      <b-row> -->
        <b-col class="sm-r5 order-smr-5 offset-smr-0" cols="6" sm="5" md="4" lg="4" xl="4" order="5" order-sm="5" order-md="4" order-lg="4" order-xl="4" offset="0" offset-sm="0" offset-md="0" offset-lg="0" offset-xl="0">
          <div class="mar-img4">
            <div class="service-content">
              <b-img :src="require('../../assets/mar/img/shutterstock.jpg')" fluid alt="Responsive image"></b-img>
              <div class="hover-service hover-mar4">
                <p>Mar<br> Mediterráneo</p>
              </div>
            </div>
            <div class="mar-txt">
              <p>
                Mar Mediterráneo
                <br>
                <span>Website</span>
              </p>
              <div class="text-left">
                <a href="https://marabunta.work/docs/Mar-Mediterraneo-Website.pdf" target="_blank">
                  Descarga el catálogo
                  <span><icon-base icon-name="Arrow Down"><icon-arrow-down /></icon-base></span>
                </a>
              </div>
            </div>
          </div>
        </b-col>
        <b-col class="mar-row5 sm-r10 order-smr-4 offset-r4 offset-smr-2" cols="8" sm="7" md="7" lg="7" xl="6" order="4" order-sm="4" order-md="5" order-lg="5" order-xl="5" offset="4" offset-sm="2" offset-md="1" offset-lg="1" offset-xl="2">
          <div class="mar-img5">
            <div class="service-content">
              <b-img :src="require('../../assets/mar/img/blue-water-wallpaper.jpg')" fluid alt="Responsive image"></b-img>
              <div class="hover-service hover-mar5">
                <p>Mar<br> Adriático</p>
              </div>
            </div>
            <div class="mar-txt text-right">
              <p>
                Mar Adriático
                <br>
                <span>Website con E-Commerce</span>
              </p>
              <div class="text-right">
                <a href="https://marabunta.work/docs/Mar-Adriatico-Ecommerce.pdf" target="_blank">
                  Descarga el catálogo
                  <span><icon-base icon-name="Arrow Down"><icon-arrow-down /></icon-base></span>
                </a>
              </div>
            </div>
          </div>
        </b-col>
      <!-- </b-row> -->
      <!-- <b-row>  -->
        <b-col class="sm-r5 order-smr-6 offset-r0 offset-smr-2" cols="6" sm="5" md="4" lg="4" xl="4" order="6" order-sm="6" order-md="6" order-lg="6" order-xl="6" offset="0" offset-sm="2" offset-md="4" offset-lg="4" offset-xl="3">
          <div class="mar-img6">
            <div class="service-content">
              <b-img :src="require('../../assets/mar/img/ocean-wave.jpg')" fluid alt="Responsive image"></b-img>
              <div class="hover-service hover-mar6">
                <p>Mar<br> Arábigo</p>
              </div>
            </div>
            <div class="mar-txt">
              <p>
                Mar Arábigo
                <br>
                <span>Digital Events</span>
              </p>
              <div class="text-right">
                <a href="https://marabunta.work/docs/Mar-Arabigo-DigitalEvents.pdf" target="_blank">
                  Descarga el catálogo
                  <span><icon-base icon-name="Arrow Down"><icon-arrow-down /></icon-base></span>
                </a>
              </div>
            </div>
          </div>
        </b-col>
        <b-col class="sm-r5 order-smr-8 offset-smr-7" cols="6" sm="5" md="4" lg="4" xl="4" order="8" order-sm="8" order-md="7" order-lg="7" order-xl="7" offset="6" offset-sm="7" offset-md="0" offset-lg="0" offset-xl="1">
          <div class="mar-img7">
            <div class="service-content">
              <b-img :src="require('../../assets/mar/img/Rectangulo_13.jpg')" fluid alt="Responsive image"></b-img>
              <div class="hover-service hover-mar7">
                <p>Mar<br> Caspio</p>
              </div>
            </div>
            <div class="mar-txt text-center">
              <p>
                Mar Caspio
                <br>
                <span>Animaciones</span>
              </p>
              <div class="text-center">
                <a href="https://marabunta.work/docs/Mar-Caspio-Animaciones.pdf" target="_blank">
                  Descarga el catálogo
                  <span><icon-base icon-name="Arrow Down"><icon-arrow-down /></icon-base></span>
                </a>
              </div>
            </div>
          </div>
        </b-col>
      <!-- </b-row> -->
      <!-- <b-row>  -->
        <b-col class="mar-row8 sm-r10 order-smr-7" cols="8" sm="7" md="7" lg="7" xl="6" order="7" order-sm="7" order-md="8" order-lg="8" order-xl="8">
          <div class="mar-img8">
            <div class="service-content">
              <b-img :src="require('../../assets/mar/img/ocean.jpg')" fluid alt="Responsive image"></b-img>
              <div class="hover-service hover-mar8">
                <p>Mar<br> Cantábrico</p>
              </div>
            </div>
            <div class="mar-txt">
              <p>
                Mar Cantábrico
                <br>
                <span>Diseño Gráfico</span>
              </p>
              <div class="dowload-mar8">
                <a href="https://marabunta.work/docs/Mar-Cantabrico-DiseñoGrafico.pdf" target="_blank">
                  Descarga el catálogo
                  <span><icon-base icon-name="Arrow Down"><icon-arrow-down /></icon-base></span>
                </a>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="customers-separation">
        <b-col cols="12" sm="12" md="12" lg="11" xl="9">
          <div class="txt-customers">
            <b-row>
              <b-col cols="12" sm="12" md="3" lg="3" xl="3">
                <h2>CLIENTES</h2>
              </b-col>
              <b-col class="cust-sep" cols="10" sm="12" md="9" lg="9" xl="9" offset="1" offset-sm="0" offset-md="0" offset-lg="0" offset-xl="0">
                <p>Estamos orgullosas de haber colaborado en el crecimiento de marcas de todas las industrias; estos son algunos:</p>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row class="justify-content-center logos-separation">
        <b-col class="row-logos" cols="12" sm="12" md="9" lg="9" xl="8" offset-md="3" offset-lg="3" offset-xl="0">
          <b-row align-v="center" class="customers-logos text-center">
            <b-col cols="6" sm="4" md="4" lg="4" xl="4">
              <div>
                <b-img :src="require('../../assets/img/Logo2Tor_Gris.png')" fluid alt="Responsive image"></b-img>
              </div>
            </b-col>
            <b-col cols="6" sm="4" md="4" lg="4" xl="4">
              <div>
                <b-img :src="require('../../assets/img/LogoChefTete_Gris.png')" fluid alt="Responsive image"></b-img>
              </div>
            </b-col>
            <b-col cols="6" sm="4" md="4" lg="4" xl="4">
              <div class="imgCus-3">
                <b-img :src="require('../../assets/img/Eufloria.png')" fluid alt="Responsive image"></b-img>
              </div>
            </b-col>
            <b-col cols="6" sm="4" md="4" lg="4" xl="4">
              <div class="imgCus-4">
                <b-img :src="require('../../assets/img/LemonDecor.png')" fluid alt="Responsive image"></b-img>
              </div>
            </b-col>
            <b-col cols="6" sm="4" md="4" lg="4" xl="4">
              <div class="imgCus-5">
                <b-img :src="require('../../assets/img/PBG.png')" fluid alt="Responsive image"></b-img>
              </div>
            </b-col>
            <b-col cols="6" sm="4" md="4" lg="4" xl="4">
              <div class="imgCus-6">
                <b-img :src="require('../../assets/img/LogoXbatt_Gris.png')" fluid alt="Responsive image"></b-img>
              </div>
            </b-col>
            <b-col cols="6" sm="4" md="4" lg="4" xl="4">
              <div class="imgCus-6">
                <b-img :src="require('../../assets/img/Bluemarine-G.png')" fluid alt="Responsive image"></b-img>
              </div>
            </b-col>
            <b-col cols="6" sm="4" md="4" lg="4" xl="4">
              <div class="imgCus-6">
                <b-img :src="require('../../assets/img/ClaudiaGonzalez-G.png')" fluid alt="Responsive image"></b-img>
              </div>
            </b-col>
            <b-col cols="6" sm="4" md="4" lg="4" xl="4">
              <div class="imgCus-6">
                <b-img :src="require('../../assets/img/HappyPocket-G.png')" fluid alt="Responsive image"></b-img>
              </div>
            </b-col>
            <b-col cols="6" sm="4" md="4" lg="4" xl="4">
              <div class="imgCus-6">
                <b-img :src="require('../../assets/img/Kalosoma-G.png')" fluid alt="Responsive image"></b-img>
              </div>
            </b-col>
            <b-col cols="6" sm="4" md="4" lg="4" xl="4">
              <div class="imgCus-6">
                <b-img :src="require('../../assets/img/Mazatli-G.png')" fluid alt="Responsive image"></b-img>
              </div>
            </b-col>
            <b-col cols="6" sm="4" md="4" lg="4" xl="4">
              <div class="imgCus-6">
                <b-img :src="require('../../assets/img/MHFisio-G.png')" fluid alt="Responsive image"></b-img>
              </div>
            </b-col>
            <b-col cols="6" sm="4" md="4" lg="4" xl="4">
              <div class="imgCus-6">
                <b-img :src="require('../../assets/img/MiOriental-G.png')" fluid alt="Responsive image"></b-img>
              </div>
            </b-col>
            <b-col cols="6" sm="4" md="4" lg="4" xl="4">
              <div class="imgCus-6">
                <b-img :src="require('../../assets/img/PERSAT-G.png')" fluid alt="Responsive image"></b-img>
              </div>
            </b-col>
            <b-col cols="6" sm="4" md="4" lg="4" xl="4">
              <div class="imgCus-6">
                <b-img :src="require('../../assets/img/UMA-G.png')" fluid alt="Responsive image"></b-img>
              </div>
            </b-col>
            <b-col cols="6" sm="4" md="4" lg="4" xl="4">
              <div class="imgCus-6">
                <b-img :src="require('../../assets/img/XENT-G.png')" fluid alt="Responsive image"></b-img>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col cols="12" class="txt-project">
          <div class="txt-centrar text-center">
            <div>
              <p>¿TIENES UN PROYECTO EN MENTE?</p>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    </b-container>
  </section>
</template>

<style>
  .gotham-book-regular{
    font-family: "Gotham Book Regular";
  }
  .set_size{
    width: 90% !important;
  }
  .logo-mar{
    margin-top: 50px;
  }
  .logoMar-responsive{
    display: none;
    margin-top: 30px;
  }
  .logoMar-responsive img{
    width: 45%;
  }
  .sections-name li a{
    font-size: 20px;
    color: #1D1D1D !important;
    border-bottom: 2px solid #AFC5D9;
    opacity: 1;
    display: inline-block;
    padding-bottom: 4px;
    line-height: 28px;
  }
  .sections-name li:hover a{
    border-bottom: 2px solid #04182E;
  }
  .img-home{
    grid-template-columns: 2fr 5fr 5fr 2fr;
    grid-template-rows: 2fr 5fr 5fr 2fr;
    display: grid;
    margin: 0;
    max-width: 100%;
    padding: 0;
  }
  .img-home div:nth-child(1){
    grid-row: 1/span 3;
    grid-column: 1/span 3;
    z-index: 1;
  }

  .img-home div:nth-child(2){
    background-color: #A9E8DC;
    grid-row: 2/span 3;
    grid-column: 2/span 3;
  }
  .txt-img{
    position: absolute;
    color: #04182E;
    font-family: "Baskerville";
    font-size: 60px;
    letter-spacing: 4.62px;
    line-height: 69px;

    /* position: relative; */
    top: 45%;
    left: -210px;
    -ms-transform: translateY(-45%);
    -webkit-transform: translateY(-45%);
    transform: translateY(-45%);
  }
  .img-home div:nth-child(1) img:nth-child(3){
    position: absolute;
    top: -12%;
    right: 11%;
    z-index: -1;    
  }
  .img-home div:nth-child(1) img:nth-child(4){
    position: absolute;
    bottom: 10%;
    right: 18%;
  }
  .img-home div:nth-child(2) img{
    position: absolute;
    bottom: -60px;
    right: -100px;
  }
  
  .nav-separation{
    margin-top: 80px;
  }
  .about-separation{
    margin-top: 200px;
  }
  .txt-about p{
    font-family: "Gotham Book Regular";
    color: #1D1D1D;
    font-size: 20px;
    letter-spacing: 1.54px;
    line-height: 28px;
  }
  .txt-about span{
    font-family: "Gotham Medium Regular";
  }
  .services-separation{
    margin-top: 300px;
  }
  .txt-services h2{
    color: #1D2B3C;
    font-family: "Baskerville";
    font-size: 40px;
    letter-spacing: 3.08px;
    line-height: 46px;
  }
  .txt-services p{
    color: #1D1D1D;
    font-family: "Gotham Book Regular";
    font-size: 20px;
    letter-spacing: 1.54px;
    line-height: 28px;
    margin-top: 40px;
  }
  .content-separation{
    margin-top: 150px;
  }
  .service-content{
    position: relative;
    align-content: center;
  }
  .service-content:hover{
    transform: scale(1.05);
  }
  .service-content:hover .hover-service {
    opacity: 1;
  }
  .hover-service{
    width: 100%;
    height: 100%;
    /* background: #1d2b3c65; */
    opacity: 0;
    transition: .5s ease;
    position: absolute;
    top: 0%;
    text-align: center;
  }
  .hover-service p{
    font-family: "KhalidRegular";
    font-size: 300px;
    color:white;
    padding:15px;
    margin-top: 15%;
    line-height: 150px;
    text-align: left;
    text-shadow: 15px 15px 10px #ffffff;
  }
  .hover-mar2 p{
    margin-top: 70%;
    text-align: right;
  }
  .hover-mar4 p{
    margin-top: 70%;
  }
  .hover-mar6 p{
    margin-left: 10%;
  }
  .hover-mar7 p{
    margin-top: 50%;
    text-align: right;
  }
  .mar-img2{
    margin-top: 250px;
  }
  .mar-img3{
    margin-top: 100px;
  }
  .mar-img5{
    margin-top: 150px;
  }
  .mar-img6{
    margin-top: -20px;
  }
  .mar-img7{
    margin-top: 200px;
  }
  .mar-img8{
    margin-top: -350px;
  }
  .dowload-mar8{
    margin-top: -45px !important;
    text-align: right !important;
  }
  .mar-txt{
    margin-top: 45px;
  }
  .mar-txt div{
    margin-top: 50px;
  }
  .mar-txt p{
    color: #1D2B3C;
    cursor: pointer;
    font-family: "Baskerville";
    font-size: 30px;
    letter-spacing: 2.31px;
    line-height: 34px;
  }
  .mar-txt div a:hover{
    border-bottom: 2px solid #04182E;
    text-decoration: none !important;
  }
  .mar-txt div a:hover svg{
    color: #1284A8;
  }
  .mar-txt p span, .mar-txt div a{
    color: #1D1D1D;
    font-family: "Gotham Book Regular";
    font-size: 20px;
    letter-spacing: 1.54px;
    line-height: 28px;
  }
  .no-show{
    display: none;
  }
  .mar-txt div a{
    border-bottom: 2px solid #AFC5D9;
    opacity: 1;
    display: inline-block;
    cursor: pointer;
  }
  .mar-txt div a svg{
    color: #2ABBC9;
    width: 14px;
  }
  .mar-txt div a span{
    position: relative;
    top: 5px;
  } 
  .customers-separation{
    margin-top: 400px;
  }
  .txt-customers h2{
    color: #1D2B3C;
    font-family: "Baskerville";
    font-size: 40px;
    letter-spacing: 3.08px;
    line-height: 46px;
  }
  .txt-customers p{
    color: #1D1D1D;
    font-family: "Gotham Book Regular";
    font-size: 20px;
    letter-spacing: 1.54px;
    line-height: 28px;
    margin-left: 0px;
  }
  .logos-separation{
    margin-top: 75px;
  }
  .customers-logos img{
    width: 50%;
  }
  .imgCus-4, .imgCus-5, .imgCus-6{
    margin-top: 20%;
  }
  .txt-project{
    display: table;
    height: 100vh;
  }
  .txt-centrar{
    display: table-cell;
    vertical-align: middle;
  }
  .txt-centrar div{
    background-image: url("../../assets/mar/img/fondo_project.png");
    background-position: 65% 40px;
    background-repeat: no-repeat;
    background-size: 60%;
    height: 150px;
  }
  .txt-centrar p{
    color: #04182E;
    font-family: "Baskerville";
    font-size: 60px;
    letter-spacing: 4.62px;
    line-height: 69px;
  }

  @media (max-width: 1800px) {
    .logo-mar img{
      width: 90%;
    }
    .sections-name li a{
      font-size: 16px;
      line-height: 25px;
    }
    .txt-img{
      font-size: 55px;
      letter-spacing: 4px;
      line-height: 65px;
      left: -190px;
    }
    .txt-about p{
      font-size: 16px;
      letter-spacing: 1.23px;
      line-height: 25px;
    }
    .txt-services h2{
      font-size: 36px;
      letter-spacing: 2.8px;
      line-height: 35px;
    }
    .txt-services p{
      font-size: 16px;
      letter-spacing: 1.23px;
      line-height: 25px;
    }
    .hover-service p{
      font-size: 280px;
      line-height: 140px;
    }
    .hover-mar4 p{
      font-size: 260px;
    }
    .mar-txt p{
      font-size: 26px;
      letter-spacing: 2px;
      line-height: 30px;
    }
    .mar-txt p span, .mar-txt div a{
      font-size: 16px;
      letter-spacing: 1.23px;
      line-height: 25px;
    }
    .txt-customers h2{
      font-size: 36px;
      letter-spacing: 2.8px;
      line-height: 35px;
    }
    .txt-customers p{
      font-size: 16px;
      letter-spacing: 1.23px;
      line-height: 25px;
    }
    .txt-centrar p{
      font-size: 55px;
      letter-spacing: 4px;
      line-height: 65px;
    }
  }
  @media (max-width: 1600px) {
    .logo-mar img{
      width: 80%;
    }
    .txt-img{
      font-size: 50px;
      letter-spacing: 3.8px;
      line-height: 60px;
      left: -170px;
    }
    .hover-service p{
      font-size: 250px;
      line-height: 120px;
    }
    .hover-mar4 p{
      font-size: 220px;
    }
    .mar-img2{
      margin-top: 200px;
    }
    .mar-img3{
      margin-top: 50px;
    }
    .mar-img5{
      margin-top: 100px;
    }
    .mar-img8{
      margin-top: -300px;
    }
    .txt-customers p{
      margin-left: 10px;
    }
    .customers-logos img{
      width: 60%;
    }
    .txt-centrar p{
      font-size: 50px;
      letter-spacing: 3.8px;
      line-height: 60px;
    }
  }
  @media (max-width: 1400px) {
    .logo-mar img{
      width: 70%;
    }
    .txt-img{
      font-size: 45px;
      letter-spacing: 3.6px;
      line-height: 55px;
      left: -152px;
    }
    .img-home div:nth-child(1) img:nth-child(3){
      height: 48%;  
    }
    .img-home div:nth-child(1) img:nth-child(4){
      width: 35%;
    }
    .mar-img8{
      margin-top: -250px;
    }
    .img-home div:nth-child(2) img{
      bottom: -50px;
      right: -80px;
      width: 20%;
    }
    .hover-service p{
      font-size: 230px;
      line-height: 110px;
    }
    .hover-mar4 p{
      font-size: 190px;
    }
    .txt-centrar p{
      font-size: 45px;
      letter-spacing: 3.6px;
      line-height: 55px;
    }
    .txt-centrar div{
      background-position: 70% 40px;
      background-size: 70%;
    }
    .txt-customers p{
      margin-left: 40px;
    }
  }
  @media (max-width: 1200px) {
    .set_size{
      width: 92% !important;
    }
    .hover-service p{
      font-size: 210px;
      line-height: 100px;
    }
    .hover-mar4 p{
      font-size: 160px;
    }
  }
  @media (max-width: 1024px) {
    .set_size{
      width: 95% !important;
    }
    .txt-customers p{
      margin-left: 60px;
    }
    .logo-mar img {
      width: 61%;
    }
    .sections-name{
      margin-top: -30px;
    }
    .sections-name li a {
        line-height: 22px;
    }
    .txt-img {
      font-size: 40px;
      letter-spacing: 3.08px;
      line-height: 46px;
      left: -130px;
    }
    .about-separation {
      margin-top: 300px;
    }
    .txt-about p {
      line-height: 28px;
    }
    .services-separation {
        margin-top: 300px;
    }
    .txt-services h2 {
        font-size: 25px;
        letter-spacing: 1.93px;
        line-height: 28px;
    }
    .txt-services p {
      font-size: 16px;
      letter-spacing: 1.23px;
      line-height: 28px;
      margin-top: 30px;
    }
    .mar-txt p {
      font-size: 25px;
      letter-spacing: 1.93px;
      line-height: 28px;
    }
    .mar-txt p span, .mar-txt div a {
      line-height: 28px;
    }
    .mar-img2 {
      margin-top: 160px;
    }
    .mar-img5 {
      margin-top: 50px;
    }
    .logos-separation {
      margin-top: 55px;
    }
    .txt-centrar p {
      font-size: 40px;
      letter-spacing: 3.08px;
      line-height: 46px;
    }
    .txt-centrar div {
      background-position: 80% 30px;
    }
    .txt-customers h2 {
      font-size: 40px;
      letter-spacing: 3.08px;
      line-height: 46px;
    }
    .txt-customers p {
      font-size: 16px;
      letter-spacing: 1.23px;
      line-height: 28px;
    }
  }
  @media (max-width: 991px) {
    .mar-img7{
      margin-top: 130px;
    }
    .mar-img8{
      margin-top: -220px;
    }
    .hover-service p{
      font-size: 120px;
      line-height: 60px;
    }
    .hover-mar4 p{
      font-size: 100px;
    }
    .img-home div:nth-child(2) img {
      bottom: -35px;
      right: -55px;
    }
  }
  @media (max-width: 812px) {
    .set_size .navbar{
      padding-bottom: 0;
    }
    .logo-mar {
      margin-top: 20px;
    }
    .logo-mar img {
      width: 50%;
    }
    .sections-name{
      margin-top: -40px;
    }
    .sections-name li a {
      font-size: 15px;
      line-height: 21px;
    }
    .nav-separation {
      margin-top: 0px;
    }
    .txt-img {
      font-size: 30px;
      letter-spacing: 2.31px;
      line-height: 34px;
      left: -95px;
    }
    .img-home div:nth-child(2) img {
      bottom: -20px;
      right: -25px;
      width: 15%;
    }
    .about-separation {
      margin-top: 72px;
    }
    .txt-about p {
      font-size: 14px;
      letter-spacing: 1.08px;
      line-height: 28px;
    }
    .services-separation {
      margin-top: 90px;
    }
    .txt-services h2 {
      font-size: 20px;
      letter-spacing: 1.54px;
      line-height: 23px;
    }
    .txt-services p {
      font-size: 14px;
      letter-spacing: 1.08px;
      line-height: 28px;
      margin-top: 20px;
    }
    .content-separation {
      margin-top: 50px;
    }
    .mar-txt p {
      font-size: 20px;
      letter-spacing: 1.54px;
      line-height: 23px;
    }
    .mar-txt p span, .mar-txt div a {
      font-size: 14px;
      letter-spacing: 1.08px;
      line-height: 28px;
    }
    .mar-txt div {
      margin-top: 20px;
    }
    .mar-img2 {
      margin-top: 60px;
    }
    .mar-img3 {
      margin-top: 25px; 
    }
    .mar-img5 {
      margin-top: 30px;
    }
    .mar-img6 {
      margin-top: -75px;
    }
    .mar-img7 {
      margin-top: 105px;
    }
    .mar-img8 {
      margin-top: -220px;
    }
    .mar-row5{
      flex: 0 0 61.333% !important;
      max-width: 61.333% !important;
      margin-left: 5.333% !important;
    }
    .mar-row8{
      flex: 0 0 61.333% !important;
      max-width: 61.333% !important;
    }
    .dowload-mar8 {
      margin-top: -55px !important;
    }
    .customers-separation {
      margin-top: 230px;
    }
    .txt-customers h2 {
      font-size: 20px;
      letter-spacing: 1.54px;
      line-height: 23px;
      text-align: center;
      padding-top: 5px;
    }
    .txt-customers p {
      font-size: 14px;
      letter-spacing: 1.08px;
      line-height: 28px;
      margin-left: -5px;
    }
    .logos-separation {
      margin-top: 30px;
    }
    .txt-centrar p {
      font-size: 30px;
      letter-spacing: 2.31px;
      line-height: 34px;
      height: 76px;
    }
    .row-logos{
      margin-left: 20% !important;
      flex: 0 0 80% !important;
      max-width: 80% !important;
    }
    .txt-centrar div {
      background-position: 70% 20px;
    }
  }
  @media (max-width: 768px) {
    .sm-r5{
      -webkit-box-flex: 0 !important;
      -webkit-flex: 0 0 41.6666666667% !important;
      -ms-flex: 0 0 41.6666666667% !important;
      flex: 0 0 41.6666666667% !important;
      max-width: 41.6666666667% !important;
    }
    .sm-r7{
      -webkit-box-flex: 0 !important;
      -webkit-flex: 0 0 58.3333333333% !important;
      -ms-flex: 0 0 58.3333333333% !important;
      flex: 0 0 58.3333333333% !important;
      max-width: 58.3333333333% !important;
    }
    .sm-r9{
      -webkit-box-flex: 0 !important;
      -webkit-flex: 0 0 75% !important;
      -ms-flex: 0 0 75% !important;
      flex: 0 0 75% !important;
      max-width: 75% !important;
    }
    .sm-r10{
      -webkit-box-flex: 0 !important;
      -webkit-flex: 0 0 83.3333333333% !important;
      -ms-flex: 0 0 83.3333333333% !important;
      flex: 0 0 83.3333333333% !important;
      max-width: 83.3333333333% !important;
    }
    .order-smr-1 {
      -webkit-box-ordinal-group: 2 !important;
      -webkit-order: 1 !important;
          -ms-flex-order: 1 !important;
              order: 1 !important;
    }
    .order-smr-2 {
      -webkit-box-ordinal-group: 3 !important;
      -webkit-order: 2 !important;
          -ms-flex-order: 2 !important;
              order: 2 !important;
    }
    .order-smr-3 {
      -webkit-box-ordinal-group: 4 !important;
      -webkit-order: 3 !important;
          -ms-flex-order: 3 !important;
              order: 3 !important;
    }
    .order-smr-4 {
      -webkit-box-ordinal-group: 5 !important;
      -webkit-order: 4 !important;
          -ms-flex-order: 4 !important;
              order: 4 !important;
    }
    .order-smr-5 {
      -webkit-box-ordinal-group: 6 !important;
      -webkit-order: 5 !important;
          -ms-flex-order: 5 !important;
              order: 5 !important;
    }
    .order-smr-6 {
      -webkit-box-ordinal-group: 7 !important;
      -webkit-order: 6 !important;
          -ms-flex-order: 6 !important;
              order: 6 !important;
    }
    .order-smr-7 {
      -webkit-box-ordinal-group: 8 !important;
      -webkit-order: 7 !important;
          -ms-flex-order: 7 !important;
              order: 7 !important;
    }
    .order-smr-8 {
      -webkit-box-ordinal-group: 9 !important;
      -webkit-order: 8 !important;
          -ms-flex-order: 8 !important;
              order: 8 !important;
    }
    .offset-smr-0 {
      margin-left: 0 !important;
    }
    .offset-smr-1 {
      margin-left: 8.3333333333% !important;
    }
    .offset-smr-2 {
      margin-left: 16.6666666667% !important;
    }
    .offset-smr-3 {
      margin-left: 25% !important;
    }
    .offset-sm-5 {
      margin-left: 41.6666666667% !important;
    }
    .offset-smr-7 {
      margin-left: 58.3333333333% !important;
    }
    .logo-mar {
      margin-top: 30px;
    }
    .logo-mar img {
      width: 80%;
    }
    .sections-name{
      margin-top: -45px;
    }
    .sections-name li a {
      font-size: 16px;
      line-height: 22px;
    }
    .nav-separation {
      margin-top: 65px;
    }
    .txt-img {
      font-size: 40px;
      letter-spacing: 3.08px;
      line-height: 46px;
      left: -135px;
    }
    .img-home{
      grid-template-rows: 1fr 5fr 5fr 1fr;
      height: 700px;
    }
    .img-home div:nth-child(1) img:nth-child(2){
      height: 100%; 
    }
    .img-home div:nth-child(1) img:nth-child(3) {
      height: 25%;
      top: -6%;
    }
    .img-home div:nth-child(1) img:nth-child(4) {
      bottom: 6%;
      right: 18%;
    }
    .img-home div:nth-child(2) img {
      bottom: -65px;
      right: -40px;
      width: 25%;
    }
    .row-home{
      margin-left: 15.333% !important;
    }
    .about-separation {
      margin-top: 300px;
    }
    
    .txt-about p {
      font-size: 16px;
      letter-spacing: 1.23px;
      line-height: 28px;
    }
    .services-separation {
      margin-top: 300px;
    }
    txt-services h2 {
      font-size: 25px;
      letter-spacing: 1.93px;
      line-height: 28px;
    }
    .txt-services p {
      font-size: 16px;
      letter-spacing: 1.23px;
      line-height: 28px;
    }
    .content-separation {
      margin-top: 30px;
    }
    .mar-txt p {
      font-size: 25px;
      letter-spacing: 1.93px;
      line-height: 28px;
    }
    .mar-txt p span, .mar-txt div a {
      font-size: 16px;
      letter-spacing: 1.23px;
      line-height: 28px;
    }
    .mar-img2 {
      margin-top: 130px;
    }
    .mar-img3 {
      margin-top: -200px; 
    }
    .mar-img4 {
      margin-top: -60px; 
    }
    .mar-img5 {
      margin-top: 60px;
    }
    .mar-img6 {
      margin-top: 220px;
    }
    .mar-img7 {
      margin-top: 100px;
    }
    .mar-img8 {
      margin-top: 80px;
    }
    .customers-separation {
      margin-top: 300px;
    }
    .txt-customers h2 {
      font-size: 40px;
      letter-spacing: 3.08px;
      line-height: 46px;
      text-align: center;
      /* padding-top: 5px; */
    }
    .txt-customers p {
      font-size: 16px;
      letter-spacing: 1.23px;
      line-height: 28px;
      margin-left: 70px;
    }
    .logos-separation {
      margin-top: 30px;
    }
    .row-logos{
      margin-left: 28% !important;
      flex: 0 0 72% !important;
      max-width: 72% !important;
    }
    .customers-logos img {
      width: 80%;
    }
    .txt-centrar p {
      font-size: 40px;
      letter-spacing: 3.08px;
      line-height: 46px;
      margin-left: 8%;
      margin-right: 8%;
    }
    .txt-centrar div {
      background-position: 50% 70px;
    } 
  }
  @media (max-width: 767px) {
    .row-logos{
      margin-left: 0% !important;
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
  }
  @media (max-width: 700px) { 
    .logo-mar {
      margin-top: 30px;
    }
    .logo-mar img {
      width: 70%;
    }
    .sections-name{
      margin-top: -30px;
    }
    .sections-name li a {
      font-size: 15px;
      line-height: 21px;
    }
    /*.nav-separation {
      margin-top: 90px;
    }*/
    .txt-img {
      font-size: 30px;
      letter-spacing: 2.31px;
      line-height: 34px;
      left: -95px;
    }
    .img-home{
      height: 600px;
    }
    .img-home div:nth-child(2) img {
      bottom: -50px;
      right: -20px;
      width: 20%;
    }
    /* .about-separation {
      margin-top: 300px;
    } */
    .txt-about p {
      font-size: 14px;
      letter-spacing: 1.08px;
      line-height: 28px;
    }
    /* .services-separation {
      margin-top: 300px;
    } */
    .txt-services h2 {
      font-size: 20px;
      letter-spacing: 1.54px;
      line-height: 23px;
    }
    .txt-services p {
      font-size: 14px;
      letter-spacing: 1.08px;
      line-height: 28px;
    }
    /* .content-separation {
      margin-top: 30px;
    } */
    .mar-txt p {
      font-size: 20px;
      letter-spacing: 1.54px;
      line-height: 23px;
    }
    .mar-txt p span, .mar-txt div a {
      font-size: 14px;
      letter-spacing: 1.08px;
      line-height: 28px;
    }
    /*.mar-img2 {
      margin-top: 130px;
    }
    .mar-img3 {
      margin-top: -200px; 
    }
    .mar-img4 {
      margin-top: -60px; 
    }
    .mar-img5 {
      margin-top: 60px;
    }
    .mar-img6 {
      margin-top: 220px;
    }
    .mar-img7 {
      margin-top: 100px;
    }
    .mar-img8 {
      margin-top: 80px;
    }*/
    /* .customers-separation {
      margin-top: 300px;
    } */
    .txt-customers h2 {
      font-size: 25px;
      letter-spacing: 1.93px;
      line-height: 28px;
      text-align: center;
     }
    .txt-customers p {
      font-size: 14px;
      letter-spacing: 1.08px;
      line-height: 28px;
      margin-left: 0px;
    }
    /*.logos-separation {
      margin-top: 30px;
    }
    .row-logos{
      margin-left: 28% !important;
      flex: 0 0 72% !important;
      max-width: 72% !important;
    }
    .customers-logos img {
      width: 80%;
    }*/
    .txt-centrar p {
      font-size: 35px;
      letter-spacing: 3.08px;
      line-height: 46px;
      margin-left: 0%;
      margin-right: 0%;
    }
    /*.txt-centrar div {
      background-position: 50% 70px;
    } */
  }
  @media (max-width: 650px) {
    .logo-mar {
      margin-top: 20px;
    }
    .logo-mar img {
      width: 80%;
    }
    .sections-name{
      margin-top: -20px;
    }
  }
  @media (max-width: 600px) {
    .logo-mar {
      margin-top: 15px;
    }
    .logo-mar img {
      width: 100%;
    }
    .sections-name{
      margin-top: -10px;
    }
  }
  @media (max-width: 575px) {
    .col-6 {
      flex: 0 0 50% !important;
      max-width: 50% !important;
    }
    .offset-r0{
      margin-left: 0% !important;
    }
    .offset-r4{
      margin-left: 33.3333333333% !important;
    }
    .offset-smr-1{
      margin-left: 0% !important;
    }
    /* .offset-smr-2{
      margin-left: 0% !important;
    } */
    .offset-smr-7 {
      margin-left: 50% !important;
    }
    .sm-r10 {
      flex: 0 0 66.666667% !important;
      max-width: 0 0 66.666667% !important;
    }
    .logo-mar{
      display: none !important;
    }
    .logoMar-responsive{
      display: block;
    }
    .set_size nav{
      padding-right: 0;
      padding-left: 0;
      padding-top: 35px;
    }
    .nav-separation {
      margin-top: 150px;
    }
    .about-separation {
      margin-top: 220px;
    }
    .sections-name{
      margin-right: auto;
    }
    .row-home{
      margin-left: 0% !important;
    }
    .txt-img{
      left: -1px;
      top: -1%;
    }
    /* .logo-mar {
      margin-top: 30px;
    } */
    /* .logo-mar img {
      width: 80%;
    } */
    /* .sections-name{
      margin-top: -45px;
    } */
    /* .sections-name li a {
      font-size: 16px;
      line-height: 22px;
    } */
    /* .nav-separation {
      margin-top: 90px;
    }
    .txt-img {
      font-size: 40px;
      letter-spacing: 3.08px;
      line-height: 46px;
      left: -135px;
    } */
    .img-home{
      grid-template-rows: 1fr 5fr 5fr 1fr;
      height: 550px;
    }
    /*.img-home div:nth-child(1) img:nth-child(2){
      height: 100%; 
    }
    .img-home div:nth-child(1) img:nth-child(3) {
      height: 25%;
      top: -6%;
    }
    .img-home div:nth-child(1) img:nth-child(4) {
      bottom: 6%;
      right: 18%;
    }
    .img-home div:nth-child(2) img {
      bottom: -65px;
      right: -40px;
      width: 25%;
    }
    .row-home{
      margin-left: 15.333% !important;
    }
    .about-separation {
      margin-top: 300px;
    }
    
    .txt-about p {
      font-size: 16px;
      letter-spacing: 1.23px;
      line-height: 28px;
    }
    .services-separation {
      margin-top: 300px;
    }*/
    .txt-services h2 {
      font-size: 20px;
      letter-spacing: 1.54px;
      line-height: 23px;
    }
    /* .txt-services p {
      font-size: 16px;
      letter-spacing: 1.23px;
      line-height: 28px;
    } */
    .content-separation {
      margin-top: 30px !important;
    }
    .mar-txt p {
      font-size: 15px;
      letter-spacing: 1.16px;
      line-height: 17px;
    }
    .mar-txt p span, .mar-txt div a {
      font-size: 11px;
      letter-spacing: 0.85px;
      line-height: 28px;
    }
    /*.mar-img2 {
      margin-top: 130px;
    }*/
    .mar-img3 {
      margin-top: -20px; 
    }
    .mar-img4 {
      margin-top: -20px; 
    }
    /* .mar-img5 {
      margin-top: 60px;
    }
    .mar-img6 {
      margin-top: 160px;
    } */
    /*.mar-img7 {
      margin-top: 100px;
    }
    .mar-img8 {
      margin-top: 80px;
    }
    .customers-separation {
      margin-top: 300px;
    }
    .txt-customers h2 {
      font-size: 40px;
      letter-spacing: 3.08px;
      line-height: 46px;
      text-align: center; */
      /* padding-top: 5px; */
    /* }
    .txt-customers p {
      font-size: 16px;
      letter-spacing: 1.23px;
      line-height: 28px;
      margin-left: 70px;
    }
    .logos-separation {
      margin-top: 30px;
    }
    .row-logos{
      margin-left: 28% !important;
      flex: 0 0 72% !important;
      max-width: 72% !important;
    }
    .customers-logos img {
      width: 80%;
    }
    .txt-centrar p {
      font-size: 40px;
      letter-spacing: 3.08px;
      line-height: 46px;
      margin-left: 8%;
      margin-right: 8%;
    }
    .txt-centrar div {
      background-position: 50% 70px;
    }  */
    .mar-txt div a svg {
      width: 11px;
    }
    .mar-txt div a span {
      top: 8px;
    }
    .txt-customers h2 {
      font-size: 20px;
      letter-spacing: 1.54px;
      line-height: 23px;
      text-align: center;
    }
    .txt-centrar p {
      font-size: 30px;
      letter-spacing: 2.31px;
      line-height: 51px;
    }
  }
 @media (max-width: 450px) {
   .sections-name li a {
      font-size: 13px;
      line-height: 19px;
    }
   .sections-name .mr-5{
      margin-right: 1rem !important;
    }
    .img-home{
      height: 450px;
    }
    .mar-txt {
      margin-top: 30px;
    }
    .img-home div:nth-child(2) img {
      bottom: -35px;
      right: -10px;
    }
    .mar-txt p {
      letter-spacing: 1px;
      line-height: 17px;
    }
    .mar-txt p span, .mar-txt div a {
      letter-spacing: 0.40px;
    }
    .hover-service p {
      font-size: 100px;
      line-height: 45px;
    }
    .hover-mar4 p {
      font-size: 75px;
    }
    .mar-img6 .mar-txt p {
      text-align: right;
    }
    .dowload-mar8 {
      margin-top: 0px !important;
      text-align: left !important;
    }
    .mar-img2 {
      margin-top: 80px;
    }
    /* .mar-img3 {
      margin-top: -20px; 
    }
    .mar-img4 {
      margin-top: -20px; 
    } */
    /* .mar-img5 {
      margin-top: 60px;
    }*/
    .mar-img6 {
      margin-top: 160px;
    }
    .mar-img7 {
      margin-top: 50px;
    }
    .mar-img8 {
      margin-top: 50px;
    }
    .customers-logos img {
      width: 95%;
    }
 }
@media (max-width: 434px) {
  .txt-centrar div {
    background-position: 50% 132px;
    height: 160px;
    background-size: 75%;
  }
}
@media (max-width: 375px) {
  .about-separation, .services-separation{
    margin-top: 200px;
  }
  .customers-separation {
    margin-top: 200px;
  }
  .mar-img2 {
    margin-top: 60px;
  }
  .cust-sep{
    margin-top: 5%;
  }
  .customers-logos img {
    width: 85%;
  }
  /* .mar-img3 {
    margin-top: -20px; 
  }
  .mar-img4 {
    margin-top: -20px; 
  } */
  /* .mar-img5 {
    margin-top: 60px;
  }*/
  .mar-img6 {
    margin-top: 150px;
  }
  .mar-img7 {
    margin-top: 40px;
  }
  .mar-img8 {
    margin-top: 40px;
  }
}


  /* @media (max-width: 991px) {
    .txt-customers p{
      margin-left: 120px;
    }
  }
  @media (max-width: 960px) {
    .logo-mar img{
      width: 65%;
    }
    .sections-name li a{
      font-size: 15px;
      line-height: 23px;
    }
    .txt-img{
      font-size: 32px;
      letter-spacing: 3px;
      line-height: 40px;
      left: -110px;
    }
    .img-home div:nth-child(2) img{
      bottom: -40px;
      right: -50px;
      width: 18%;
    }
    .txt-about p{
      font-size: 15px;
      letter-spacing: 1.16px;
      line-height: 23px;
    }
    .txt-services h2{
      font-size: 24px;
      letter-spacing: 1.5px;
      line-height: 20px;
    }
    .txt-services p{
      font-size: 15px;
      letter-spacing: 1.16px;
      line-height: 23px;
    }
    .hover-service p{
      font-size: 120px;
      line-height: 60px;
    }
    .mar-img4{
      margin-top: 20px;
    }
    .hover-mar4 p{
      font-size: 100px;
    }
    .mar-txt p{
      font-size: 20px;
      letter-spacing: 1px;
      line-height: 20px;
    }
    .mar-txt p span, .mar-txt div a{
      font-size: 15px;
      letter-spacing: 1.16px;
      line-height: 23px;
    }
    .mar-img8{
      margin-top: -220px;
    }
    .txt-customers h2{
      font-size: 24px;
      letter-spacing: 1.5px;
      line-height: 20px;
    }
    .txt-customers p{
      font-size: 15px;
      letter-spacing: 1.16px;
      line-height: 23px;
      margin-left: 50px;
    }
    .txt-centrar p{
      font-size: 25px;
      letter-spacing: 2px;
      line-height: 50px;
    }
  }
  @media (max-width: 767px){
    .logo-mar img{
      width: 60%;
      margin-top: -30px;
    }
    .txt-img{
      font-size: 25px;
      letter-spacing: 2.5px;
      line-height: 30px;
      left: 2px;
      top: -2%;
    }
    .mar-txt div a span{
      top: 3px;
    } 
    .img-home div:nth-child(1) img:nth-child(3){
      height: 40%;  
    }
    .img-home div:nth-child(1) img:nth-child(4){
      width: 30%;
    }
    .img-home div:nth-child(2) img{
      bottom: -40px;
      right: 0px;
      width: 15%;
    }
    .mar-img3{
      margin-top: 0px;
    }
    .mar-img5{
      margin-top: 50px;
    }
    .mar-img4{
      margin-top: 0px;
    }
    .mar-img6{
      margin-top: 200px;
    }
    .mar-img7{
      margin-top: 20px;
    }
    .mar-img8{
      margin-top: 20px;
    }
    .dowload-mar8{
      margin-top: 50px !important;
      text-align: left !important;
    }
    .txt-customers h2{
      text-align: center;
    }
    .txt-customers p{
      margin-top: 20px;
      margin-left: 0;
    }
  }
  @media (max-width: 660px){
    .logo-mar img{
      width: 75%;
      margin-top: -20px;
    }
  }
  @media (max-width: 576px){
    .logo-mar{
      display: none !important;
    }
    .set_size nav{
      padding-right: 0;
      padding-left: 0;
      padding-top: 35px;
    }
    .logoMar-responsive{
      display: block;
    }
    .nav-separation {
      margin-top: 150px;
    }
    .about-separation {
      margin-top: 220px;
    }
    .sections-name{
      margin-right: auto;
    }
    .sections-name .mr-5{
      margin-right: 1rem !important;
    }
    .customers-logos .imgCus-3, .customers-logos .imgCus-4{
      margin-top: 10%;
    }
    .customers-logos .imgCus-5, .customers-logos .imgCus-6{
      margin: 25% 0;
    }
    .mar-img2{
      margin-top: 100px;
    }
  }

  @media (max-width: 450px){
    .hover-service p {
      font-size: 90px;
      line-height: 48px;
    }
    .hover-mar4 p{
      font-size: 70px;
    }
  } */

</style>

<script>
import IconBase from './../IconBase'
import IconArrowDown from './../icons/IconArrowDown'

export default {
  name: 'HomeMar',
  components: {
    IconBase,
    IconArrowDown
	}
}
</script>